var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCalculator = function SvgIconCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.625 6.125a1 1 0 0 0 0 2h6.75a1 1 0 1 0 0-2zM9.75 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M15.75 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M9.75 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M15.75 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.5 3.75A1.75 1.75 0 0 0 18.75 2H5.25A1.75 1.75 0 0 0 3.5 3.75v16.5c0 .966.784 1.75 1.75 1.75h13.5a1.75 1.75 0 0 0 1.75-1.75zM5.5 4h13v16h-13z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconCalculator;